import { render, staticRenderFns } from "./privacy-password.vue?vue&type=template&id=10cd8536&scoped=true&"
import script from "./privacy-password.vue?vue&type=script&lang=js&"
export * from "./privacy-password.vue?vue&type=script&lang=js&"
import style0 from "./privacy-password.vue?vue&type=style&index=0&id=10cd8536&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10cd8536",
  null
  
)

export default component.exports